export default {
  disabled: 'DISABLED',
  enabled: 'ENABLED',
}
